"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ccnamelabel = exports.ccinfoitemlabel = exports.ccdetailitemlabel = exports.ccactionlabel = exports.CONTACT_CARD_WITH_HEADER_CLASSNAME = void 0;
const ccactionlabel = "notforyou-ccaction";
exports.ccactionlabel = ccactionlabel;
const ccinfoitemlabel = "notforyou-ccinfoitem";
exports.ccinfoitemlabel = ccinfoitemlabel;
const ccdetailitemlabel = "notforyou-ccdetailitem";
exports.ccdetailitemlabel = ccdetailitemlabel;
const ccnamelabel = "notforyou-ccname";
exports.ccnamelabel = ccnamelabel;
const CONTACT_CARD_WITH_HEADER_CLASSNAME = "contact-card-with-header-classname";
exports.CONTACT_CARD_WITH_HEADER_CLASSNAME = CONTACT_CARD_WITH_HEADER_CLASSNAME;
//# sourceMappingURL=constants.js.map